export const basicCardData = [
    {
      text: "This is a simple basic card using anywhere.",
    },
  ];
  
  export const flatCardData = [
    {
      text: "For flat cards, make the",
      code: ".b-r-0[border-radius:0]",
    },
    {
      text: "used class.",
    },
  ];
  
  export const withoutShadowCardDetails = [
    {
      text: "Use the",
      code: ".shadow-none ",
    },
    {
      text: "&",
      code: ".border ",
    },
    {
      text: "class through shadow removes.",
    },
  ];
  
  export const iconInHeadingData = [
    {
      text: "Use the any icons  for heading. ",
      code: "[font-awesome/ico-font/feather].",
    },
  ];
  
  export const darkColorData = [
    {
      text: "Use the",
      code: ".bg-dark ",
    },
    {
      text: "color for dark background card.",
    },
  ];
  
  export const infoColorHeaderData = [
    {
      headerClass: "bg-secondary",
      headingClass: "text-white",
      title: "Info Color Header",
      text: "Web Designer",
      span: "By following instructions and adding your own unique twist and style, you may apply your imagination as a web designer. The majority of the tasks you'll be assigned will have a specific due date and work description, but the reason you were employed was because they need a specialist to inject some much-needed creativity.",
    }
  ];
  
  export const infoColorBodyData = [
    {
      bodyClass: "bg-secondary",
      title: "Info Color Body",
      text: "UX Designer",
      span: 'It is the responsibility of the UX designer to make a product or service useful, pleasurable, and accessible. The word "user experience" is used by various industries, although it is most frequently related to digital design for websites and mobile applications.There is no need for coding in user experience design.',
    }
  ];
  
  export const infoColorFooterData = [
    {
      bodyClass: "mb-4",
      sm: "12",
      title: "Info Color Footer",
      text: "Web Developer",
      span: "A programmer who uses the client-server architecture to create World Wide Web applications is known as a web developer. The apps generally employ any general-purpose programming language on the server and HTML, CSS, and JavaScript on the client.",
      footerClass:"bg-secondary"
    }
  ];